const indiaSeoData = require("./indiaSeoData");
const sriLankaSeoData = require("./sriLankaSeoData");
const bangladeshSeoData = require("./bangladeshSeoData");

module.exports = {
  india : indiaSeoData,
  sriLanka: sriLankaSeoData,
  bangladesh: bangladeshSeoData,
}